module.exports = __webpack_public_path__ + "img/wrapbg2.98b4104f.png";